module.exports = "<div class=\"settings-expertises__header\">\n  Expertise\n</div>\n\n<expertises-table classs=\"expertises-table\"\n                  proficiencies=\"$ctrl.settings.profile.proficiencies\"\n                  on-profile-save=\"$ctrl.onProfileSave(proficiencies)\"\n                  have-actions=\"true\">\n</expertises-table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/screens/settings/screens/settings-expertises/settings-expertises.html
// module id = 339
// module chunks = 0